module.exports = __webpack_public_path__ + "img/free_multiplier_6.c94ebf84.png";